<script setup>
import { computed, getCurrentInstance } from 'vue';
import { Head, usePage } from '@inertiajs/vue3';
import { useLayout } from '@/layout/common/composables/layout';
import AdminDashboardBreadcrumb from './AdminDashboardBreadcrumb.vue';
import AdminDashboardHeader from './AdminDashboardHeader.vue';
import AdminDashboardSidebar from './AdminDashboardSidebar.vue';
import GlobalLoadingOverlay from '@/components/GlobalLoadingOverlay.vue';
import AnnouncementModal from '@/components/AnnouncementModal.vue';
import { pageTitleForRoute } from './menu.js';

const { menuMode } = useLayout();
const page = usePage();
const { proxy } = getCurrentInstance();
const $t = proxy.$t;

// Prefix every admin page title with "Admin -" so browser tabs are never
// confused with the client area. page.url keeps this reactive across Inertia
// visits (route() alone is not reactive in a persistent layout).
const documentTitle = computed(() => {
    void page.url;
    const title = pageTitleForRoute(route().current());
    return title ? `Admin - ${$t(title)}` : 'Admin';
});
</script>

<template>
    <div class="h-dvh bg-primary-50 dark:bg-surface-950 relative p-2 flex overflow-hidden" :class="menuMode === 'horizontal' ? 'flex-col' : 'flex-row'">
        <Head :title="documentTitle" />
        <AdminDashboardSidebar />
        <main class="flex-1 max-w-full w-full mx-5 flex flex-col transition-all duration-300 h-full bg-background rounded-3xl shadow-stroke overflow-hidden">
            <AdminDashboardHeader />
            <AdminDashboardBreadcrumb />
            <div class="p-3 flex-1 overflow-auto">
                <slot />
            </div>
        </main>
        <Toast position="top-right" pt:root:class="!top-20" />
        <GlobalLoadingOverlay />
        <AnnouncementModal />
    </div>
</template>
